import { all, put, takeEvery, fork } from 'redux-saga/effects'
import {loadingStart, loadingStop} from '../action'
import {push} from 'react-router-redux'
import {getFirebase} from 'react-redux-firebase'
import {store} from '../index'
const perMatch = {
    'extraversion': 0.27,
    'agreeableness': 0.26,
    'conscientiousness': 0.29,
    'desireToLearn': 0.23,
    'mastery': 0.19,
    'otherReferencedGoals': 0.04,
    'competitiveness': 0.18,
    'worry': 0.02,
    'emotionality': 0.11,
    'selfEfficacy': 0.40
}


let _wpZ = {}, _ssZ = {}, _perZ={}, _cog = 0, _finalScore = {}

function* stopLoading() {
    yield put(loadingStop())
}

function* answerTest(payload) {
    yield put(loadingStart('ส่งคำตอบ...'))
    getFirebase().ref(`tests/${payload.userId}/${payload.testType}/${payload.testIndex}`).set({
        q: payload.question,
        a: payload.answer,
        trait: payload.trait,
        time: Date.now(),
    }).then(()=>{
        switch(payload.testType) {
            case 'cognitive':
                if(payload.testIndex === 14) {
                    getFirebase().updateProfile({currentTest: 'personality', currentIndex: 0})
                } else {
                    getFirebase().updateProfile({currentIndex: payload.testIndex + 1})
                }
                break
            case 'personality': 
                if(payload.testIndex === 39) {
                    getFirebase().updateProfile({currentTest: 'softskills', currentIndex: 0})
                } else {
                    getFirebase().updateProfile({currentIndex: payload.testIndex + 1})
                }
                break
            case 'softskills': 
                if(payload.testIndex === 27) {
                    getFirebase().updateProfile({currentTest: 'wp', currentIndex: 0})
                } else {
                    getFirebase().updateProfile({currentIndex: payload.testIndex + 1})
                }
                break
            case 'wp': 
                if(payload.testIndex === 29) {
                    //getFirebase().updateProfile({currentTest: 'finished', currentIndex: null})
                    //Calculate Score
                    getFirebase().ref(`tests/${payload.userId}`).once('value', (snapshot) => {
                        const score = snapshot.val()
                        //COG
                        let cogScore = 0
                        const cogN = Object.keys(score.cognitive).length
                        for(let cog in Object.keys(score.cognitive)) {
                            (score.cognitive[cog].a === 1)?cogScore += 1:null
                        }
                        cogScore = (cogScore / cogN) * 100
                        //nsole.log('---FINAL SCORE---', score)
                        //console.log('----COGSCORE---', cogScore)
                        _cog = cogScore
                        //PERSONALITY
                        let perScore = {
                            'extraversion': 0,
                            'agreeableness': 0,
                            'conscientiousness':0,
                            'desireToLearn':0,
                            'mastery': 0,
                            'otherReferencedGoals':0,
                            'competitiveness':0,
                            'worry':0,
                            'emotionality': 0,
                            'selfEfficacy': 0
                        }
                        let perZ = {
                            'Zextraversion': 0,
                            'Zagreeableness': 0,
                            'Zconscientiousness':0,
                            'ZdesireToLearn':0,
                            'Zmastery': 0,
                            'ZotherReferencedGoals':0,
                            'Zcompetitiveness':0,
                            'Zworry':0,
                            'Zemotionality': 0,
                            'ZselfEfficacy': 0
                        }
                        for(let per in Object.keys(score.personality)) {
                            const trait = score.personality[per].trait
                            perScore[trait] += score.personality[per].a*5
                        }
                        let perSum = 0
                        for(let trait in perScore) {
                            //console.log(trait)
                            perSum += perScore[trait]
                        }
                        let perMean = perSum/10
                        let perSD = 0
                        for(let trait in perScore) {
                            perSD += Math.pow(perScore[trait]-perMean,2)
                        }
                        perSD = Math.sqrt((perSD/(10-1)))
                        for(let trait in perScore) {
                            perZ[`Z${trait}`] = (perScore[trait] - perMean) / perSD
                        }
                        _perZ = perZ
                        //console.log('---PERSCORE---', perScore)+
                        
                        //SOFTSKILLS
                        let ssScore = {'CPN': 0.0, 'PPM': 0.0, 'SMC': 0.0, 'PIS': 0.0, 'LOM': 0.0, 'PCS': 0.0, 'PEW': 0.0}
                        let ssZ = {'ZCPN': 0, 'ZPPM': 0, 'ZSMC': 0, 'ZPIS': 0, 'ZLOM': 0, 'ZPCS': 0, 'ZPEW': 0}
                        for(let ss in Object.keys(score.softskills)) {
                            const trait = score.softskills[ss].trait
                            ssScore[trait] += score.softskills[ss].a*5
                        }
                        let ssSum = 0
                        for(let trait in ssScore) {
                            //console.log(trait)
                            ssSum += ssScore[trait]
                        }
                        let ssMean = ssSum/7
                        let ssSD = 0
                        for(let trait in ssScore) {
                            ssSD += Math.pow(ssScore[trait]-ssMean,2)
                        }
                        ssSD = Math.sqrt((ssSD/(7-1)))
                        for(let trait in ssScore) {
                            ssZ[`Z${trait}`] = (ssScore[trait] - ssMean) / ssSD
                        }
                        _ssZ = ssZ
                        //console.log('---SSSCORE---', ssScore)

                        //WP
                        let wpScore = {'WPPM': 0.0, 'WIAM': 0.0, 'WCII': 0.0, 'WICH': 0.0, 'WCEO': 0.0, 'WPAM': 0.0}
                        let wpZ = {'ZWPPM': 0, 'ZWIAM': 0, 'ZWCII': 0, 'ZWICH': 0, 'ZWCEO': 0, 'ZWPAM': 0}
                        for(let wp in Object.keys(score.wp)) {
                            const trait = score.wp[wp].trait
                            wpScore[trait] += score.wp[wp].a*4
                        }
                        let wpSum = 0
                        for(let trait in wpScore) {
                            //console.log(trait)
                            wpSum += wpScore[trait]
                        }
                        let wpMean = wpSum/6
                        let wpSD = 0
                        for(let trait in wpScore) {
                            wpSD += Math.pow(wpScore[trait]-wpMean,2)
                        }
                        wpSD = Math.sqrt((wpSD/(6-1)))
                        for(let trait in wpScore) {
                            wpZ[`Z${trait}`] = (wpScore[trait] - wpMean) / wpSD
                        }
                        _wpZ = wpZ
                        
                        let finalScore = Object.assign({}, {COG: cogScore},{ZCOG: (4*(cogScore/100))-2}, ssScore, wpScore, wpZ, ssZ, perZ)
                        _finalScore = finalScore
                        getFirebase().updateProfile(
                            {
                                score: finalScore,
                                currentTest: 'finished', 
                                currentIndex: null
                            }
                        )

                        getFirebase().ref(`users/${payload.userId}/jobs`).once('value', (snapshot) => {
                            const jobs = snapshot.val()
                            let matching = {}
                            
                            for(let j in jobs) {
                                let wpMatch = 0
                                const job = jobs[j]
                                let diff = {}
                                for(let s in job.score) {
                                    if(s[0] === 'Z') {
                                        let jobScore = job.score[s]
                                        if(jobScore>2) jobScore = 2
                                        if(jobScore<-2) jobScore = -2                                        
                                        let myScore = _finalScore[s]
                                        if(myScore>2) myScore = 2
                                        if(myScore<-2) myScore = -2      
                                        diff[s] = (myScore - jobScore)*25
                                        if(s[1] === 'W') {
                                            //console.log(diff[s])
                                            wpMatch += Math.abs(diff[s])
                                        }
                                    }
                                }
                                wpMatch /= 6
                                let cognitiveMatch = Math.abs(diff.ZCOG)
                                let softskillsMatch = 
                                    ((Math.abs(diff.Zagreeableness) + 
                                        Math.abs(diff.Zcompetitiveness) + 
                                        Math.abs(diff.Zconscientiousness) + 
                                        Math.abs(diff.ZdesireToLearn) +
                                        Math.abs(diff.Zemotionality) +
                                        Math.abs(diff.Zextraversion) +
                                        Math.abs(diff.Zmastery) + 
                                        Math.abs(diff.ZotherReferencedGoals) + 
                                        Math.abs(diff.ZselfEfficacy) +
                                        Math.abs(diff.Zworry))/20)
                                    +
                                    ((
                                        Math.abs(diff.ZCPN) + Math.abs(diff.ZLOM) + Math.abs(diff.ZPCS) + Math.abs(diff.ZPEW) + Math.abs(diff.ZPIS) + Math.abs(diff.ZPPM) + Math.abs(diff.ZSMC)
                                    )/14)
                                matching[j] = Object.assign({},diff,{cognitiveMatch: 100-Math.abs(cognitiveMatch)}, {softskillsMatch: 100-Math.abs(softskillsMatch)},{wpMatch: 100-Math.abs(wpMatch)}, 
                                    {totalMatch: ((100-Math.abs(wpMatch))+(100-Math.abs(cognitiveMatch))+(100-Math.abs(softskillsMatch)))/3})
                            }
                            
                            


                            getFirebase().updateProfile({matching: matching})
                        })
                        
                        
                        store.dispatch(push('/'))



                    })

                } else {
                    getFirebase().updateProfile({currentIndex: payload.testIndex + 1})
                }
                break
            default:
                console.log('INVALID TESTTYPE!!!')
        }
    })
}
export default function* TestSaga() {
    yield takeEvery('@@test/ANSWER', answerTest)
    yield takeEvery('@@reactReduxFirebase/PROFILE_UPDATE_SUCCESS',stopLoading)
}



// WEBPACK FOOTER //
// ./src/test/saga.js